import { render, staticRenderFns } from "./OnThisDay.vue?vue&type=template&id=716c2350&scoped=true"
import script from "./OnThisDay.vue?vue&type=script&lang=ts"
export * from "./OnThisDay.vue?vue&type=script&lang=ts"
import style0 from "./OnThisDay.vue?vue&type=style&index=0&id=716c2350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c2350",
  null
  
)

export default component.exports